<template>
	<div class="fc-slider">
		<div class="ui-slider-handle fc-cursor">
			<div class="fc-value-0"></div>
		</div>
		<div class="ui-slider-handle fc-cursor">
			<div class="fc-value-1"></div>
		</div>
	</div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  name: 'fc-slider-range',
  props: ['value', 'ui'],
  mounted() {
    const vm = this
    $(this.$el).slider(Object.assign({
      range: true,
      create(event, ui) {
        const $this = $(this)
        $this.find('.fc-value-0').text(vm.value[0] + vm.ui.fcValueSuffix)
        $this.find('.fc-value-1').text(vm.value[1] + vm.ui.fcValueSuffix)
        $this.slider('values', vm.value)
      },
      slide(event, ui) {
        const $this = $(this)
        $this.find('.fc-value-0').text('' + ui.values[0] + vm.ui.fcValueSuffix)
        $this.find('.fc-value-1').text(ui.values[1] + '' + vm.ui.fcValueSuffix)
        vm.$emit('input', ui.values)
      },
    }, this.ui.jqoptions))
  },
  watch: {
    value(values) {
      const $el = $(this.$el)
      const ui_values = $el.slider('values')
      if (values[0] === ui_values[0] && values[1] === ui_values[1]) return

      $el.slider('values', values)
      $el.find('.fc-value-0').text('' + values[0] + this.ui.fcValueSuffix)
      $el.find('.fc-value-1').text(values[1] + '' + this.ui.fcValueSuffix)
    },
  },
}
</script>
